import { render, staticRenderFns } from "./Ssn.vue?vue&type=template&id=38c188c7&"
import script from "./Ssn.vue?vue&type=script&lang=js&"
export * from "./Ssn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports